import Vue from 'vue'
import { mapGetters } from 'vuex';

(function(window, Vue) {

  const contentString = (tooltipContent) => {
      return `
      <div class="marker-tooltip">
          <div class="marker-tooltip__holder">
              <h3 class="marker-tooltip__name">${tooltipContent.title}</h3>
              <span class="marker-tooltip__type">${tooltipContent.type}</span><br />
              <a href="tel:${tooltipContent.phone}" class="marker-tooltip__phone">${tooltipContent.phone}</a><br />
              <a href="${tooltipContent.mail}" class="marker-tooltip__mail">${tooltipContent.mail}</a><br />
              <span class="marker-tooltip__address">${tooltipContent.address}</span>
          </div>
      </div>`;
  };

  const options = {
	  disableDefaultUI: true,
	  zoomControl: false,
	  mapTypeControl: false,
	  scaleControl: false,
	  streetViewControl: false,
	  rotateControl: false,
	  fullscreenControl: false,
	  zoom: 13,
  };

  let map = null;
  let markers = [];
  let bounds = null;
  let lastInfoWindow = null;
  let googleInstance = null;

  const initializeMap = (element, options, markers) => {
    if(!google || !element) {
      return;
    }

    bounds = new google.maps.LatLngBounds();
    map = new google.maps.Map(element, options)
    addMarkers(markers);

  };

  const addMarkers = (filteredMarkers) => {

    if(!google) {
      return;
    }

	const iconOffice = {
		url: `${process.env.IMAGE_PATH}/gunnebo-offices-marker.svg`,
		anchor: new google.maps.Point(25,50),
		scaledSize: new google.maps.Size(50,50)
	}
	const iconShowroom = {
		url: `${process.env.IMAGE_PATH}/gunnebo-showrooms-marker.svg`,
		anchor: new google.maps.Point(25,50),
		scaledSize: new google.maps.Size(50,50)
	}

    filteredMarkers.forEach((coord) => {

        const position = new google.maps.LatLng(coord.latitude, coord.longitude);

        const infowindow = new google.maps.InfoWindow({
            content: contentString(coord.tooltipContent)
        });

        const marker = new google.maps.Marker({
            position,
            icon: coord.tooltipContent.type.toLowerCase() == 'office' ? iconOffice : iconShowroom,
            map
        });

        bounds.extend(marker.position);

        marker.addListener('click', function() {

            if(lastInfoWindow != null) {
              lastInfoWindow.close();
            }

            lastInfoWindow = infowindow;
            infowindow.open(map, marker);
        });

        markers[coord.latitude + coord.longitude] = marker;

    });

    recenterMap(bounds);

  };

  const recenterMap = (bounds) => {
    map.fitBounds(bounds);
  };

  const updateMarkers = (filteredMarkers) => {

    if(!google) {
      return;
    }

    bounds = new google.maps.LatLngBounds();
    for(let index in markers) {
      const currentMarker = markers[index];
      const exists = filteredMarkers.filter((filteredMarker) => {
        const filteredMarkerIndex = filteredMarker.latitude + filteredMarker.longitude;
        return filteredMarkerIndex === index;
      })[0] != undefined;

      if(!exists) {
        currentMarker.setMap(null);
      } else if(currentMarker.map === null){
        currentMarker.setMap(map)
        bounds.extend(currentMarker.position);
      } else {
        bounds.extend(currentMarker.position);
      }
    }

    recenterMap(bounds);

  };

  Vue.component('GoogleMarker', {
    template: `<span></span>`,
    props: {
		latitude: {
			type: String,
			required: true
		},
		longitude: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		type: {
			type: String,
			required: true,
			validator: function(value) {
				return ['office', 'showroom'].includes(value.toLowerCase());
			},
		},
		phone: {
			type: String,
			required: true,
		},
		mail: {
			type: String,
			required: true
		},
		address: {
			type: String,
			required: true,
		},
	},
    mounted: function(){
		this.$store.dispatch('googlemap/addMarker', {
           latitude: this.latitude,
           longitude: this.longitude,
           tooltipContent: {
             title: this.title,
             type: this.type,
             phone: this.phone,
             mail: this.mail,
             address: this.address
           }
         });
    }
});

  Vue.component('GoogleMap', {
      template: `
      <div>
        <div class="google-map" :id="name"></div>
			<div class="find-us__map-search">
				<input type="text" v-model="searchTerm" v-on:input="searchMarkers" :placeholder="searchPlaceholder"/>
				<img class="find-us__map-search-icon" :src="searchIcon"></span>
			</div>
			<div class="find-us__map-filter" v-if="hasOffices && hasShowrooms">
				<label for="office">
					<img :src="officeIcon" />
					<span>{{officeFilterTitle}}</span>
					<input type="checkbox" id="office" @change="toggleFilterOffices($event)" />
				</label>
				<label for="showroom">
					<img :src="showroomIcon" />
					<span>{{showroomFilterTitle}}</span>
					<input type="checkbox" id="showroom" @change="toggleFilterShowrooms($event)"  />
				</label>
			</div>
        <slot>
        </slot>
      </div>`,
      props: {
        name: {
          type: String,
          required: true
        },
			  showroomFilterTitle: {
				  type: String,
				  required: true,
			  },
			  officeFilterTitle: {
				  type: String,
				  required: true,
			  },
		    searchPlaceholder: {
		      type: String,
		      required: false
		    }
      },
			created: function() {
				this.searchIcon = `${process.env.IMAGE_PATH}/search-icon.svg`;
				this.showroomIcon = `${process.env.IMAGE_PATH}/gunnebo-showrooms-icon.svg`;
				this.officeIcon = `${process.env.IMAGE_PATH}/gunnebo-offices-icon.svg`;
			},
		  data: function() {
			  return {
				  searchTerm: ''
			  };
		  },
      methods: {
        searchMarkers: function() {
					this.$store.dispatch('googlemap/search', this.searchTerm);
        },
				toggleFilterOffices: function($event) {
					this.$store.dispatch('googlemap/filterByOffices', $event.target.checked);
				},
				toggleFilterShowrooms: function($event) {
					this.$store.dispatch('googlemap/filterByShowrooms', $event.target.checked);
				}
      },
      watch: {
        filteredMarkers: function() {
          if(this.filteredMarkers.length == 0 || !map){
            return;
          }
          updateMarkers(this.filteredMarkers);
        }
      },
      mounted: function () {
        this.$nextTick(function () {
          initializeMap(document.getElementById(this.name), options, this.filteredMarkers);
		  updateMarkers(this.filteredMarkers);
        });
	  },
	  computed: {
        ...mapGetters({
  			filteredMarkers: 'googlemap/getFilteredMarkers',
			search: 'googlemap/getSearchTerm',
			hasOffices: 'googlemap/hasOffices',
			hasShowrooms: 'googlemap/hasShowrooms',
        })
      },
  });

}(window, Vue));



// WEBPACK FOOTER //
// ./components/google-map/google-map.js